export type ActionType =
  | "invalid"
  | "autocreate_every_second"
  | "TOGGLE_USE_ACTION_ROWS"
  | "TOGGLE_USE_INVENTORY_ROWS"
  | "TOGGLE_ACTION_USER_VISIBILITY"
  | "TOGGLE_BRICK_USER_VISIBILITY"
  | "ADD_ACTION_TIMESTAMP"
  | "CLEAN_OLD_TIMESTAMPS"
  | "SAVE_GAME"
  | "LOAD_GAME"
  | "buy_brick_pack"
  | "SET_BRICK_PACK_BUY_AMOUNT"
  | "SET_SET_BUY_AMOUNT"
  | "collect_3005"
  | "create_3004"
  | "create_3010"
  | "create_3003"
  | "create_3001"
  | "split_3005_into_3024"
  | "split_3004_into_3023"
  | "split_3010_into_3710"
  | "split_3003_into_3022"
  | "split_3001_into_3020"
  | "auto_collect_3005"
  | "auto_collect_3004"
  | "auto_collect_3024"
  | "auto_collect_3023"
  | "auto_collect_3010"
  | "auto_collect_3003"
  | "auto_collect_3001"
  | "auto_collect_3022"
  | "auto_collect_3710"
  | "auto_collect_3020"
  | "increase_capacity_3004"
  | "increase_capacity_3023"
  | "increase_capacity_3024"
  | "increase_capacity_3010"
  | "increase_capacity_3005"
  | "increase_capacity_3003"
  | "increase_capacity_3001"
  | "increase_capacity_3022"
  | "increase_capacity_3710"
  | "increase_capacity_3020"
  | "auto_collect_3005_10"
  | "auto_collect_3004_10"
  | "auto_collect_3024_10"
  | "auto_collect_3023_10"
  | "auto_collect_3010_10"
  | "auto_collect_3003_10"
  | "auto_collect_3001_10"
  | "auto_collect_3710_10"
  | "auto_collect_3022_10"
  | "auto_collect_3020_10"
  | "increase_capacity_3005_100"
  | "increase_capacity_3004_100"
  | "increase_capacity_3024_100"
  | "increase_capacity_3023_100"
  | "increase_capacity_3010_100"
  | "increase_capacity_3003_100"
  | "increase_capacity_3001_100"
  | "increase_capacity_3710_100"
  | "increase_capacity_3022_100"
  | "increase_capacity_3020_100"
  | "increase_capacity_3005_350"
  | "increase_capacity_3004_350"
  | "increase_capacity_3024_350"
  | "increase_capacity_3023_350"
  | "increase_capacity_3010_350"
  | "increase_capacity_3003_350"
  | "increase_capacity_3001_350"
  | "increase_capacity_3710_350"
  | "increase_capacity_3022_350"
  | "increase_capacity_3020_350"
  | "auto_collect_3005_75"
  | "auto_collect_3004_75"
  | "auto_collect_3024_75"
  | "auto_collect_3023_75"
  | "auto_collect_3010_75"
  | "auto_collect_3003_75"
  | "auto_collect_3001_75"
  | "auto_collect_3710_75"
  | "auto_collect_3022_75"
  | "auto_collect_3020_75"
  | "auto_collect_3005_250"
  | "auto_collect_3004_250"
  | "auto_collect_3024_250"
  | "auto_collect_3023_250"
  | "auto_collect_3010_250"
  | "auto_collect_3003_250"
  | "auto_collect_3001_250"
  | "auto_collect_3710_250"
  | "auto_collect_3022_250"
  | "auto_collect_3020_250"
  | "increase_capacity_3005_1000"
  | "increase_capacity_3004_1000"
  | "increase_capacity_3024_1000"
  | "increase_capacity_3023_1000"
  | "increase_capacity_3010_1000"
  | "increase_capacity_3003_1000"
  | "increase_capacity_3001_1000"
  | "increase_capacity_3710_1000"
  | "increase_capacity_3022_1000"
  | "increase_capacity_3020_1000"
  | "upgrade_brickpack_sloped_bricks_part_one"
  | "upgrade_brickpack_minifig_utensils_part_one"
  | "upgrade_brickpack_bionicles_part_one"
  | "upgrade_brickpack_animals_part_one"
  | "upgrade_brickpack_minifig_utensils_part_two"
  | "upgrade_brickpack_bionicles_part_two"
  | "upgrade_brickpack_circular_bricks"
  | "upgrade_brickpack_minifig_hair"
  | "upgrade_brickpack_technic_bricks"
  | "upgrade_brickpack_minifig_headgear"
  | "increase_capacity_brickpack_sloped_bricks_part_one"
  | "increase_capacity_brickpack_minifig_utensils_part_one"
  | "increase_capacity_brickpack_bionicles_part_one"
  | "increase_capacity_brickpack_animals_part_one"
  | "increase_capacity_brickpack_minifig_utensils_part_two"
  | "increase_capacity_brickpack_bionicles_part_two"
  | "increase_capacity_brickpack_circular_bricks"
  | "increase_capacity_brickpack_minifig_hair"
  | "increase_capacity_brickpack_technic_bricks"
  | "increase_capacity_brickpack_minifig_headgear"
  | "auto_collect_brickpack_sloped_bricks_part_one"
  | "auto_collect_brickpack_minifig_utensils_part_one"
  | "auto_collect_brickpack_bionicles_part_one"
  | "auto_collect_brickpack_animals_part_one"
  | "auto_collect_brickpack_minifig_utensils_part_two"
  | "auto_collect_brickpack_bionicles_part_two"
  | "auto_collect_brickpack_circular_bricks"
  | "auto_collect_brickpack_minifig_hair"
  | "auto_collect_brickpack_technic_bricks"
  | "auto_collect_brickpack_minifig_headgear"
  | "increase_capacity_brickpack_sloped_bricks_part_one_75"
  | "increase_capacity_brickpack_minifig_utensils_part_one_75"
  | "increase_capacity_brickpack_bionicles_part_one_75"
  | "auto_collect_brickpack_sloped_bricks_part_one_15"
  | "auto_collect_brickpack_minifig_utensils_part_one_15"
  | "auto_collect_brickpack_bionicles_part_one_15"
  | "increase_capacity_brickpack_animals_part_one_75"
  | "increase_capacity_brickpack_minifig_utensils_part_two_75"
  | "increase_capacity_brickpack_bionicles_part_two_75"
  | "auto_collect_brickpack_animals_part_one_15"
  | "auto_collect_brickpack_minifig_utensils_part_two_15"
  | "auto_collect_brickpack_bionicles_part_two_15"
  | "increase_capacity_brickpack_circular_bricks_75"
  | "increase_capacity_brickpack_minifig_hair_75"
  | "increase_capacity_brickpack_technic_bricks_75"
  | "increase_capacity_brickpack_minifig_headgear_75"
  | "auto_collect_brickpack_circular_bricks_15"
  | "auto_collect_brickpack_minifig_hair_15"
  | "auto_collect_brickpack_technic_bricks_15"
  | "auto_collect_brickpack_minifig_headgear_15"
  | "auto_collect_brickpack_sloped_bricks_part_one_75"
  | "auto_collect_brickpack_minifig_utensils_part_one_75"
  | "auto_collect_brickpack_bionicles_part_one_75"
  | "auto_collect_brickpack_animals_part_one_75"
  | "auto_collect_brickpack_minifig_utensils_part_two_75"
  | "auto_collect_brickpack_bionicles_part_two_75"
  | "buy_set_6772-1"
  | "buy_set_8534-1"
  | "buy_set_4866-1"
  | "buy_set_10307-1"
  | "buy_set_4432-1"
  | "buy_set_21060-1"
  | "buy_set_7146-1"
  | "buy_set_71766-1"
  | "buy_set_10305-1"
  | "buy_set_10179-1"
  | "brickpack_circular_bricks"
  | "brickpack_minifig_hair"
  | "brickpack_technic_bricks"
  | "brickpack_minifig_headgear"
  | "TOGGLE_SET_USER_VISIBILITY"
  | "SET_ACTION_ORDER"
  | "TOGGLE_EDIT_MODE"
  | "SET_INVENTORY_ORDER"
  | "TOGGLE_EDIT_MODE_INVENTORY"
  | "SET_HELP_ICON_ANIMATED";

// Type guard function
export const isValidActionType = (id: string): id is ActionType => {
  const validActionTypes: ActionType[] = [
    "autocreate_every_second",
    "TOGGLE_USE_ACTION_ROWS",
    "TOGGLE_USE_INVENTORY_ROWS",
    "TOGGLE_ACTION_USER_VISIBILITY",
    "TOGGLE_BRICK_USER_VISIBILITY",
    "ADD_ACTION_TIMESTAMP",
    "CLEAN_OLD_TIMESTAMPS",
    "SAVE_GAME",
    "LOAD_GAME",
    "buy_brick_pack",
    "SET_BRICK_PACK_BUY_AMOUNT",
    "SET_SET_BUY_AMOUNT",
    "collect_3005",
    "create_3004",
    "create_3010",
    "create_3003",
    "create_3001",
    "split_3005_into_3024",
    "split_3004_into_3023",
    "split_3010_into_3710",
    "split_3003_into_3022",
    "split_3001_into_3020",
    "auto_collect_3005",
    "auto_collect_3004",
    "auto_collect_3024",
    "auto_collect_3023",
    "auto_collect_3010",
    "auto_collect_3003",
    "auto_collect_3001",
    "auto_collect_3022",
    "auto_collect_3710",
    "auto_collect_3020",
    "increase_capacity_3005",
    "increase_capacity_3004",
    "increase_capacity_3023",
    "increase_capacity_3024",
    "increase_capacity_3010",
    "increase_capacity_3003",
    "increase_capacity_3001",
    "increase_capacity_3022",
    "increase_capacity_3710",
    "increase_capacity_3020",
    "auto_collect_3005_10",
    "auto_collect_3004_10",
    "auto_collect_3024_10",
    "auto_collect_3023_10",
    "auto_collect_3010_10",
    "auto_collect_3003_10",
    "auto_collect_3001_10",
    "auto_collect_3710_10",
    "auto_collect_3022_10",
    "auto_collect_3020_10",
    "increase_capacity_3005_100",
    "increase_capacity_3004_100",
    "increase_capacity_3024_100",
    "increase_capacity_3023_100",
    "increase_capacity_3010_100",
    "increase_capacity_3003_100",
    "increase_capacity_3001_100",
    "increase_capacity_3710_100",
    "increase_capacity_3022_100",
    "increase_capacity_3020_100",
    "increase_capacity_3005_350",
    "increase_capacity_3004_350",
    "increase_capacity_3024_350",
    "increase_capacity_3023_350",
    "increase_capacity_3010_350",
    "increase_capacity_3003_350",
    "increase_capacity_3001_350",
    "increase_capacity_3710_350",
    "increase_capacity_3022_350",
    "increase_capacity_3020_350",
    "auto_collect_3005_75",
    "auto_collect_3004_75",
    "auto_collect_3024_75",
    "auto_collect_3023_75",
    "auto_collect_3010_75",
    "auto_collect_3003_75",
    "auto_collect_3001_75",
    "auto_collect_3710_75",
    "auto_collect_3022_75",
    "auto_collect_3020_75",
    "auto_collect_3005_250",
    "auto_collect_3004_250",
    "auto_collect_3024_250",
    "auto_collect_3023_250",
    "auto_collect_3010_250",
    "auto_collect_3003_250",
    "auto_collect_3001_250",
    "auto_collect_3710_250",
    "auto_collect_3022_250",
    "auto_collect_3020_250",
    "increase_capacity_3005_1000",
    "increase_capacity_3004_1000",
    "increase_capacity_3024_1000",
    "increase_capacity_3023_1000",
    "increase_capacity_3010_1000",
    "increase_capacity_3003_1000",
    "increase_capacity_3001_1000",
    "increase_capacity_3710_1000",
    "increase_capacity_3022_1000",
    "increase_capacity_3020_1000",
    "upgrade_brickpack_sloped_bricks_part_one",
    "upgrade_brickpack_minifig_utensils_part_one",
    "upgrade_brickpack_bionicles_part_one",
    "upgrade_brickpack_animals_part_one",
    "upgrade_brickpack_minifig_utensils_part_two",
    "upgrade_brickpack_bionicles_part_two",
    "upgrade_brickpack_circular_bricks",
    "upgrade_brickpack_minifig_hair",
    "upgrade_brickpack_technic_bricks",
    "upgrade_brickpack_minifig_headgear",
    "increase_capacity_brickpack_sloped_bricks_part_one",
    "increase_capacity_brickpack_minifig_utensils_part_one",
    "increase_capacity_brickpack_bionicles_part_one",
    "increase_capacity_brickpack_animals_part_one",
    "increase_capacity_brickpack_minifig_utensils_part_two",
    "increase_capacity_brickpack_bionicles_part_two",
    "increase_capacity_brickpack_circular_bricks",
    "increase_capacity_brickpack_minifig_hair",
    "increase_capacity_brickpack_technic_bricks",
    "increase_capacity_brickpack_minifig_headgear",
    "auto_collect_brickpack_sloped_bricks_part_one",
    "auto_collect_brickpack_minifig_utensils_part_one",
    "auto_collect_brickpack_bionicles_part_one",
    "auto_collect_brickpack_animals_part_one",
    "auto_collect_brickpack_minifig_utensils_part_two",
    "auto_collect_brickpack_bionicles_part_two",
    "auto_collect_brickpack_circular_bricks",
    "auto_collect_brickpack_minifig_hair",
    "auto_collect_brickpack_technic_bricks",
    "auto_collect_brickpack_minifig_headgear",
    "increase_capacity_brickpack_sloped_bricks_part_one_75",
    "increase_capacity_brickpack_minifig_utensils_part_one_75",
    "increase_capacity_brickpack_bionicles_part_one_75",
    "auto_collect_brickpack_sloped_bricks_part_one_15",
    "auto_collect_brickpack_minifig_utensils_part_one_15",
    "auto_collect_brickpack_bionicles_part_one_15",
    "increase_capacity_brickpack_animals_part_one_75",
    "increase_capacity_brickpack_minifig_utensils_part_two_75",
    "increase_capacity_brickpack_bionicles_part_two_75",
    "auto_collect_brickpack_animals_part_one_15",
    "auto_collect_brickpack_minifig_utensils_part_two_15",
    "auto_collect_brickpack_bionicles_part_two_15",
    "increase_capacity_brickpack_circular_bricks_75",
    "increase_capacity_brickpack_minifig_hair_75",
    "increase_capacity_brickpack_technic_bricks_75",
    "increase_capacity_brickpack_minifig_headgear_75",
    "auto_collect_brickpack_circular_bricks_15",
    "auto_collect_brickpack_minifig_hair_15",
    "auto_collect_brickpack_technic_bricks_15",
    "auto_collect_brickpack_minifig_headgear_15",
    "auto_collect_brickpack_sloped_bricks_part_one_75",
    "auto_collect_brickpack_minifig_utensils_part_one_75",
    "auto_collect_brickpack_bionicles_part_one_75",
    "auto_collect_brickpack_animals_part_one_75",
    "auto_collect_brickpack_minifig_utensils_part_two_75",
    "auto_collect_brickpack_bionicles_part_two_75",
    "buy_set_6772-1",
    "buy_set_8534-1",
    "buy_set_4866-1",
    "buy_set_10307-1",
    "buy_set_4432-1",
    "buy_set_21060-1",
    "buy_set_7146-1",
    "buy_set_71766-1",
    "buy_set_10305-1",
    "buy_set_10179-1",
    "brickpack_circular_bricks",
    "brickpack_minifig_hair",
    "brickpack_technic_bricks",
    "brickpack_minifig_headgear",
    "TOGGLE_SET_USER_VISIBILITY",
    "SET_ACTION_ORDER",
    "TOGGLE_EDIT_MODE",
    "SET_INVENTORY_ORDER",
    "TOGGLE_EDIT_MODE_INVENTORY",
    "SET_HELP_ICON_ANIMATED",
  ];

  return validActionTypes.includes(id as ActionType);
};

export interface ActionTimestamp {
  id: string;
  amount: number;
  timestamp: number;
}

export interface Action {
  type: ActionType;
  actionTimestamp?: ActionTimestamp;
  rowChange?: boolean;
  buyAmount?: number;
  brickPackId?: string;
  saveData?: any; // SaveData from saveLoad.ts (avoiding circular dependency)
  actionId?: string; // For TOGGLE_ACTION_USER_VISIBILITY
  brickId?: string; // For TOGGLE_BRICK_USER_VISIBILITY
  setId?: string; // For TOGGLE_SET_USER_VISIBILITY
  brickPackBuyAmount?: number; // For SET_BRICK_PACK_BUY_AMOUNT
  setBuyAmount?: number; // For SET_SET_BUY_AMOUNT
  actionOrder?: string[]; // For SET_ACTION_ORDER
  editModeActive?: boolean; // For TOGGLE_EDIT_MODE
  inventoryOrder?: string[]; // For SET_INVENTORY_ORDER
  editModeInventory?: boolean; // For TOGGLE_EDIT_MODE_INVENTORY
  helpIconAnimated?: boolean; // For SET_HELP_ICON_ANIMATED
}
